import { render, staticRenderFns } from "./Dock.vue?vue&type=template&id=14fecf53&"
import script from "./Dock.vue?vue&type=script&lang=js&"
export * from "./Dock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports